import { useContext } from 'react'
import type { ReactNode } from 'react'
import { AppShellContext } from '@/components/layout/AppShellContext'
import { LedgerNav } from '@/components/ledger/LedgerNav'
import { LedgerFooter } from '@/components/ledger/LedgerFooter'
import { ThemeProvider } from '@/components/theme-provider'

export function RecoveryShell({ children }: { children: ReactNode }) {
  const nested = useContext(AppShellContext)
  if (nested) return <section className="ledger-wrap py-16 md:py-24">{children}</section>
  return <ThemeProvider defaultTheme="system" storageKey="horizon-tech-theme"><div className="ledger-body ledger-ground flex min-h-screen flex-col">
    <LedgerNav />
    <main id="main-content" tabIndex={-1} className="ledger-wrap flex-1 py-16 md:py-24">{children}</main>
    <LedgerFooter />
  </div></ThemeProvider>
}
